
<main>
   <!-- displaying error message -->
   <div  *ngIf="failuremessage" class="container-box" id="error-container">
    <div class="alert valign-children-middle mar-top-20" id="alert-container">
        <div class="alert-error" aria-label="Alert." id="alert-error-container">
            <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div id="error-message-container">
            <p id="error-message">{{notificationdata.failuremessage}}</p>
        </div>
    </div>
  </div>
 <!-- displaying success message -->
  <div *ngIf="formSuccess" id="success-main-container">
    <div class="container-box" id="success-container">
        <div class="alert valign-children-middle" id="alert-success-container" >
            <div class="alert-success">
                <i class="icon-approval" aria-hidden="true"></i>
            </div>
            <div id="success-message-container">
              <p id="success-message">{{notificationdata.successMessage}}</p>
            </div>
        </div>
    </div>
  </div>
  <div class="manage-notification">
      
        <br>
        <h3>{{this.notificationdata.subhead}} </h3><br>
        <p><strong>Foundation Account : </strong>{{this.fan}}</p>
        
        <p class="edit-text">
          {{this.notificationdata.selectednotificationTmp}} 
        </p>
        
       <div *ngFor="let data of nestedjson; let i = index"class="check-data">
        <label>
        <input type="checkbox" id="email" [(ngModel)]="checkedItems[i].checked" 
         (change)="changeEvent(checkedItems[i])"/>
        {{data.name}}
        </label>
        <div *ngIf="data.name == 'Text Messages'" class="tooltip-input inline-labels">
          <i class="icon-flat-faq tooltip-icon bottom-tooltip faq-tooltip-icon" tabindex="0" aria-describedby="inputhelp"
            (mouseenter)="toggleTooltipEnter($event)" (mouseleave)="toggleTooltipLeave($event)" aria-label="Help"></i>
          <div role="tooltip" class="helper-text" id="inputhelp">{{this.notificationdata.tooltipTextMessage}}
        </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-sm-12 col-md-12 text-right buttons-section">
          <button aria-label="Continue"(click)="submit()" 
          [disabled]="!this.selectedbox"
          type="submit"  class="btn btn-secondary pull-right">
          {{this.notificationdata.buttons.submit}}   </button>
          <a href="manageInventory" class="btn btn-link btn-block btn-cancel btnCancel"> 
            {{this.notificationdata.buttons.cancel}}  </a>
        </div>
     </div>
        
  </div>
</main>